import { render, staticRenderFns } from "./CompanyLicenseSetting.vue?vue&type=template&id=2ae0146c"
import script from "./CompanyLicenseSetting.vue?vue&type=script&lang=js"
export * from "./CompanyLicenseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae0146c')) {
      api.createRecord('2ae0146c', component.options)
    } else {
      api.reload('2ae0146c', component.options)
    }
    module.hot.accept("./CompanyLicenseSetting.vue?vue&type=template&id=2ae0146c", function () {
      api.rerender('2ae0146c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyLicenseSetting.vue"
export default component.exports